import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import ArticlesBlockEmbed from './articles-block-embed'

export const fragment = `
  articlesCollection {
    items {
      headline
      slug
      image {
        url
        description
      }
    }
  }
`

export const QUERY = gql`
query RecommendedArticles($id: String!) {
  recommendedArticles(id: $id) {
    ${fragment}
  }
}
`

export default function ArticlesBlockEmbedWithData({ id }) {
  return (
    <Query query={QUERY} variables={{ id }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.recommendedArticles
        return (
          <ArticlesBlockEmbed {...response} />
        )
      }}
    </Query>
  )
}

ArticlesBlockEmbedWithData.propTypes = {
  id: PropTypes.string.isRequired,
}
